<template>
	<div class="w-100">
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div class="w-100" v-if="parseInt(acceptCountryFlag) == 1">
			<div class="px-5">
				<h4 class="title pb-3 border-bottom text-left mb-4" v-show="iframeVar">{{$t('letVerifyYou')}}</h4>

				<h4 class="title pb-3 border-bottom text-left mb-4" v-show="!iframeVar && !inManual">{{$t('reviewing')}}</h4>

				<h4 class="title pb-3 border-bottom text-left mb-4" v-show="inManual">{{$t('dataMisMatchDoc')}}</h4>
			</div>
			<div class="w-100 px-5 scrollbar">
				
				<div class="row" v-show="iframeVar"> 
					<div class="col-12 setUpFxaccount mb-2" v-show='!startIpv'>
					  <div class="icotitle mb-3">
						<h3>
						  <img src="../../../../static/fxView/images/steps.svg" alt="">
						  {{$t('verifyIdentity')}} <!--<a href="#" class=" ml-2 router-link-exact-active router-link-active" v-on:click.prevent='iframeVar=false'>{{$t('havingTrouble')}}</a>-->
						</h3>
					  </div>
					  <ul class="stepListing">
						<li>
						  <div class="left">
							<i class="ico">{{$t('one')}}</i>{{$t('stepMsz12')}}
							<div class="identy_list" v-html="$t('idenProofText')"></div>
						  </div>
						  
						</li>
						<li>
						  <div class="left">
							<i class="ico">{{$t('two')}}</i>{{$t('holdDocFrontSide')}}
							<div class="identy_list" v-html="$t('resProofText')"></div>
						  </div>
						  
						</li>
						<li>
						  <div class="left">
							<i class="ico">{{$t('three')}}</i>{{$t('holdDocBackSide')}}
							<div class="identy_list" v-html="$t('insText')"></div>
						  </div>
						  
						</li>
					  </ul>
					</div>
					
					<div class="col-12" v-on:click.prevent="startIpvNow()" v-show='!startIpv'>
						<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
							<!-- <div class="leftbtn">
								<a href="#" class=" ml-2 router-link-exact-active router-link-active">{{$t('dontHaveWebCame')}}</a>
							</div> -->
							<button class="prism_btn btn_sm">{{$t('letBegin')}}</button>
						</div>
					</div>

				   <div class="col-12" v-show='startIpv'>
						<div id="idensic" class="w-100 height65"></div>
				   </div> 
				</div> 
				
				<div class="reviewingApplication" v-show="showFeaturesDiv">
					<div class="text-center">
						<h3 class="mb-4">{{$t('WhileReviewYourApp')}}</h3>
					</div>
					<div class="readnewas text-center row d-flex align-items-center justify-content-center">
						<div class="col-4">
							<div class="nws border radiusbold p-3 mb-3 ">
								<div class="mb-2">
									<img class="ico_thumb" src="../../../../static/fxView/images/news_ico.svg" alt="News">
								</div>
								<p class="mb-2">{{$t('readTradeNews')}}</p>
								<a href="/trade-news">{{$t('clickHere')}}</a>
							</div>
						</div>
						<div class="col-4">
							<div class="nws border radiusbold p-3 mb-3">
								<div class="mb-2">
									<img class="ico_thumb" src="../../../../static/fxView/images/trading_ideas.svg" alt="News">
								</div>
								<p class="mb-2">{{$t('readTradeIdeaAuto')}}</p>
								<a href="/auto-chartist">{{$t('clickHere')}}</a>
							</div>
						</div>
						<div class="col-4">
							<div class="nws border radiusbold p-3 mb-3">
								<div class="mb-2">
									<img class="ico_thumb" src="../../../../static/fxView/images/trading_ideas.svg" alt="News">
								</div>
								<p class="mb-2">{{$t('readTradeIdeaSignal')}}</p>
								<a href="/economic-calendar">{{$t('clickHere')}}</a>
							</div>
						</div> 
					</div>
				</div>
				
				<div v-show="asktoallowNotification">
					<div class="text-center">
						<h3 class="mb-4">{{$t('appSubTakeTime')}} </h3>
					</div>
					<div class="row d-flex align-items-center justify-content-center text-center">
						<div class="col-12 col-md-8">
							<div class="border-bottom pb-3 mb-3">
								<p>{{$t('deniNotificAcc')}} </p> 
							</div> 
							<div class="border-bottom pb-3 mb-3">
								<div class="desc"> 
									<h4 class="mb-2">{{$t('whyWeAllow')}}</h4> 

									<p class="mb-2">{{$t('infoAboutAppStatus')}}</p>

									<!-- <p class="mb-2">How do you can do now. <a href="#"> Click to see.</a></p>  -->
								</div> 
							</div>  
							<div class="thumb d-flex align-items-center justify-content-center mb-3">
								 <div class="mb-3 mr-5">
									<img src="../../../../static/fxView/images/notificationenable_Step1.png" alt="enable notification setting" style="width: 250px;">
								</div>
								<div class="mb-3">
									<img src="../../../../static/fxView/images/notificationenable_Step2.png" alt="enable notification setting" style="width: 250px;">
								</div>
							</div> 
							<div class="clearfix"></div>
							<div class="border-top pt-3 mb-3"> 
								<router-link to="#" v-on:click.prevent="dontwanttoallow()">{{$t('clickHere')}} </router-link> {{$t('toSkip')}}
							</div>
						</div> 
					</div> 
				</div>
				
			</div> 

			<div v-show="riskDiv">
				<label class="text-left fancy_radiochk_btn">{{$t('acceptRisk')}}
					<input type="checkbox" class="form-control" v-model="check1" v-validate="'required'" name="check1"  ><span class="checkmark" :class="{ 'is-invalid': submitted && errors.has('check1') }" ref="check1Input"></span>
				</label>
				<button class="prism_btn btn_sm" v-on:click.prevent="riskFunc()">{{$t('saveContinue')}} </button>
			</div>

			<div class="px-5 text-center" v-show="inManual">

				<p class="title pb-3 border-bottom mb-4">
					{{$t('stepMsz13')}}  
					<router-link :to="{name: 'fxView.support' , params: { 'tabName':'openRequest'}}">{{$t('clickHere')}}</router-link> {{$t('toViewTicket')}}
				</p>
				<div class="icon mb-5">
					<img src="../../../../static/fxView/images/document_mismatch.svg" alt="Email Support" style = "height: 350px !important;">
				</div>
				
			</div>
			
			<div class="px-5  text-center " v-show="allOkay">
				
				<div class="icon mb-5">
					<img src="../../../../static/fxView/images/verificatioin_success.svg" alt="Email Support" style = "height: 350px !important;">
				</div>
				<p class="title pb-3 border-bottom mb-4">{{$t('stepMsz14')}}</p>
				<router-link to="/create-live-account" class="prism_btn btn_sm ">
				 {{$t('createLiveAccount')}}
				</router-link>
			</div>
			
			<div class="scrollbar" v-if="resolveMismatch">
					<div class="px-5">
						<p class="title pb-3 border-bottom text-left mb-4" v-show="addressMatched == 1 && idMatched == 1">While validating your proof of address document, we noticed that the address and ID number entered during registration does not match the document uploaded during verification.</p>

						<p class="title pb-3 border-bottom text-left mb-4" v-show="addressMatched == 1 && idMatched != 1">While validating your proof of address document, we noticed that the address entered during registration does not match the document uploaded during verification.</p>

						<p class="title pb-3 border-bottom text-left mb-4" v-show="addressMatched != 1 && idMatched == 1">While validating your proof of address document, we noticed that the ID number entered during registration does not match the document uploaded during verification.</p>
					</div>
					<div class="px-5 mb-3 "> 
						<div class="col-12" v-show="showArr[currentStep] == 'address'">
							<small class="subtitle">Original address <address> {{getUserProfile.address1}} {{getUserProfile.address2}} <br>  {{getUserProfile.city}} <br> {{getUserProfile.post_code}} <br><p v-for="clist in countriesList" v-if="clist.id == getUserProfile.residence_country">{{clist.name}}</p>  </address></small>
							<ul class="twoColumn">
								<li v-for="addressDocument, index in addressFromDocument">    
									<label class="customRadio-button"><address>{{addressDocument.subStreetEn}}  {{addressDocument.streetEn}} <br> {{addressDocument.townEn}} <br>{{addressDocument.postCode}}</address>
										<input type="radio" class="form-control" v-model="selected_address_type" :value="addressDocument" :id="'checkbox_id'+index">
										<span class="checkmark"></span>
									</label>
								</li>
								<li v-for="addressDocument, index in addressFromDocument">    
									<label class="customRadio-button">{{$t('stepMsz18')}} 
										<input type="radio" class="form-control" v-model="selected_address_type" value="-1" id="dontwanttochangeAddress">
										<span class="checkmark"></span>
									</label>
								</li>
							</ul>
							<div class="row">
								<div class="col-12">
									<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
										<div class="leftbtn">
											<button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('preQues')}}</button>
										</div> 
										<button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('nextQues')}}</button> 
										<button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('stepMsz21')}} </button>
									</div>
								</div>
							</div>
						</div> 

						<div class="col-12" v-show="showArr[currentStep] == 'nationalid'">
							<h6 class="subtitle">{{$t('idNumEnt')}} {{getUserProfile.P_IDNUMBER}}</h6>
							<ul class="twoColumn">
								<li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'number' in idNumberDocument">   
									<label class="customRadio-button">
										<address>{{idNumberDocument.number}}</address>
										<input type="radio" class="form-control" v-model="selected_id_type" :value="idNumberDocument.number" :id="'checkbox'+index">
										<span class="checkmark"></span>
									</label>
								</li>
								<li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'additionalNumber' in idNumberDocument">   
									<label class="customRadio-button">
										<address>{{idNumberDocument.additionalNumber}}</address>
										<input type="radio" class="form-control" v-model="selected_id_type" :value="idNumberDocument.additionalNumber" :id="'checkbox'+index">
										<span class="checkmark"></span>
									</label>
								</li>
								<li>    
									<label class="customRadio-button">{{$t('stepMsz18')}}
										<input type="radio" class="form-control" v-model="selected_id_type" value="-1" id="dontwanttochange">
										<span class="checkmark"></span>
									</label>
								</li>
							</ul>
							<div class="row">
								<div class="quesPercntBar col-12 mb-3" v-show="false">
									<span>0 {{$t('percentComplete')}}</span>
									<div class="progressBar progress">
										 <div class="progress-bar" role="progressbar"  aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
								</div>
								<div class="col-12">
									<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
										<div class="leftbtn">
											<button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('preQues')}}</button>
										</div> 
										<button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('nextQues')}}</button> 
										<button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('stepMsz21')}} </button>
									</div>
								</div>
							</div>
						</div> 

						<div class="col-12" v-show="showArr[currentStep] == 'nationality'">
							<h6 class="subtitle">{{$t('nationalityEntered')}} <p for="checkbox_id" v-for="list in countriesList" v-if="list.iso2.toUpperCase() == getUserProfile.nationality.toUpperCase()"> {{list.name}}</p></h6>
							<ul class="twoColumn">
								<li v-for="(idNumberDocument, index) in idNumberFromDocument" v-if="'number' in idNumberDocument">    
									<label class="customRadio-button">
										
										<p for="checkbox_id" v-for="list in countriesList" v-if="list.iso2.toUpperCase() == idNumberDocument.country.substr(0,2).toUpperCase()"> 
											{{list.name}}
										</p>

										<input type="radio" class="form-control" v-model="selected_nationality" :value="idNumberDocument.country.substr(0,2).toUpperCase()" :id="'checkbox'+index">
										<span class="checkmark"></span>
									</label>
								</li>
								<li>    
									<label class="customRadio-button" for="dontwanttochangeNationality">I don't want to change anything
										<input type="radio" class="form-control" v-model="selected_nationality" value="-1" id="dontwanttochangeNationality">
										<span class="checkmark"></span>
									</label>
								</li>
							</ul>
							<div class="row">
								<div class="col-12">
									<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
										<div class="leftbtn">

											<button class="prism_btn btn_sm grayBtn" v-if="currentStep!=0" v-on:click.prevent="currentStep--">{{$t('preQues')}}</button>
										</div> 
										<button class="prism_btn btn_sm" v-on:click.prevent="currentStep++" v-if="parseInt(currentStep) != showArr.length-1">{{$t('nextQues')}}</button> 
										<button class="prism_btn btn_sm" v-on:click.prevent="resolveConflict()" v-else>{{$t('stepMsz21')}} </button>
									</div>
								</div>
							</div>
						</div> 
					</div> 
			</div> 
		</div>
		<div class="p-5 acceptCountryFlagText text-center" v-else-if="parseInt(acceptCountryFlag) == 2">
			<div class="mb-2">
				<img src="../../../../static/fxView/images/review_application.svg" alt="" style="width: 250px">
			</div>
			<div v-html="$t('acceptCountryFlagText')"></div>
		</div>
		<div class="w-100 p-5 text-center" v-else>
			
			Processing.....
		</div>
	</div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    import EventBus from '@/plugins/fxView/provider/candle-history/lib/event-bus';
    import snsWebSdk from '@sumsub/websdk'; 

    export default {
        name: 'stepFive',
        mixins: [fxViewMixins],
        data() {
            return {
				acceptCountryFlag : '1',
                step : 5,
                iframeVar : true,
                inManual: false,
                riskDiv : false,
                allOkay: false,
                startIpv: false,
                iframe: {
                    src: window.location.href,
                    style: null,
                    wrapperStyle: null,
                },
                submitted : false,
                check1 : false,
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                createAccount: false,
                SumSubCurrentState:'',
                idMatched: 2,
                addressMatched: 2,
                nationalityMatched: 2,
                addressFromDocument:'',
                idNumberFromDocument:'',
                selected_address_type: '',
                selected_nationality_type: '',
                nationalityFromDocument: '',
                selected_id_type: '',
                resolveMismatch: false,
                showFeaturesDiv: false,
                asktoallowNotification: false,
                accToken: "",
                user_id: "",
                showArr: [],
                currentStep:0,
                selected_nationality:'',
                levelname: ''
            }
        },
        methods:{
            ...mapActions({
                _runRegisterStepFive: types.RUN_REGISTER_STEP5,
                _runSkipDocumentUpload: types.RUN_SKIP_DOCUMENT_UPLOAD,
                _runGetSumSubResp: types.RUN_GET_SUM_SUB_RESPONSE,
                _runGetResolveDocIssue: types.RUN_RESOLVE_DOC_ISSUE
            }),
            getSumSubResp(){
                // let input_json = {
                //     'globalParams' :{},
                //     'localParams' :{  "parameter" : this   }
                // };
                // this._runGetSumSubResp(input_json)
            },
            riskFunc(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        this.createAccount = true
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                })
            },
            subSubResp(responseFromSumSub){
                if(responseFromSumSub!=''){
                    this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : this.loaderFuncRun}})

                    this.showFeaturesDiv = false
                    this.asktoallowNotification = false
                    
                    if(parseInt(responseFromSumSub.resolved) == 1){
                        // Data Mismatch From Document
                        // A problem has occurred while validating your document automatically. We have raised a ticket to resolve this. Our support team will be in touch with you as soon as possible, and within 2 Business days.
                        //ticket link



                        this.iframeVar = false
                        this.inManual = true

                    }else{
                        if(parseInt(responseFromSumSub.overallstatus) == 2){

                            //sumsubresp
                            const sumsubResp = JSON.parse(responseFromSumSub.sumsubresp)
                            if(responseFromSumSub.suspicionReasons == '"PROBLEMATIC_APPLICANT_DATA"' && sumsubResp.reviewResult.reviewRejectType == 'RETRY'){
                                //Fells in manual verification
                                 // Data Mismatch From Document
		                        // A problem has occurred while validating your document automatically. We have raised a ticket to resolve this. Our support team will be in touch with you as soon as possible, and within 2 Business days.
		                        //ticket link

                                this.iframeVar = false
                                this.inManual = true
                            }

                            if(sumsubResp.reviewResult.reviewRejectType == 'FINAL'){
                                //user has to go in manual
                                  // Data Mismatch From Document
		                        // A problem has occurred while validating your document automatically. We have raised a ticket to resolve this. Our support team will be in touch with you as soon as possible, and within 2 Business days.
		                        //ticket link
                                this.iframeVar = false
                                this.inManual = true
                            }
                        }

                        if(parseInt(responseFromSumSub.overallstatus) == 1){
                        	//Thank you for verifying your identity, and welcome to FxView! You can now open a Live trading account and start trading.
                        	//create live account link
                            this.allOkay  = true
                        }

                        if(parseInt(responseFromSumSub.overallstatus) == 0){
                            // sumsubaddress
                            const sumSubAddress = JSON.parse(responseFromSumSub.sumsubaddress)

                            // let addressFound = 0
                            if(sumSubAddress.status == 1){
                                this.addressMatched = 0
                            }else{
	                            this.showArr.push('address')
	                            this.resolveMismatch = true
	                            this.addressFromDocument = sumSubAddress.address
	                            this.iframeVar = false
	                            this.addressMatched = 1
	                        }
                        
	                        const sumSubIdNumber = JSON.parse(responseFromSumSub.idnumber)

	                        if(sumSubIdNumber.status == 1){
	                            this.idMatched = 0
	                        }else{
	                            this.showArr.push('nationalid')
	                            this.resolveMismatch = true
	                            this.idNumberFromDocument = sumSubIdNumber.idnumber
	                            this.iframeVar = false
	                            this.idMatched = 1
	                        }
	                        
	                        const nationalityRespS = JSON.parse(responseFromSumSub.nationalityResp)

	                        if(nationalityRespS.status == 1){
	                            this.nationalityMatched = 0
	                        }else{
	                            this.showArr.push('nationality')
	                            this.resolveMismatch = true
	                            this.nationalityFromDocument = nationalityRespS.idnumber
	                            this.iframeVar = false
	                            this.nationalityMatched = 1
	                        }
	                    }
                    }
                }else{
                    this.startIpvNow();
                }
            },
            resolveConflict(){

                let overallStatus = 1

                if(this.idMatched == 1 && this.selected_id_type == -1){
                    overallStatus= 0
                }
                if(this.addressMatched == 1 && this.selected_address_type == -1){
                    overallStatus = 0
                }
                if(this.nationalityMatched == 1 && this.selected_nationality == -1){
                    overallStatus = 0
                }


                let formatAddress = {}
                if(this.addressMatched == 1 && this.selected_address_type != -1){
                    formatAddress.address1 = this.selected_address_type.subStreetEn.trim() +" "+this.selected_address_type.streetEn.trim()
                    formatAddress.city = this.selected_address_type.townEn.trim()
                    formatAddress.post_code = this.selected_address_type.postCode.trim()
                    formatAddress.residence_country = this.selected_address_type.country.substr(0,2)
                }

                let globalParameter = {}

                if(this.addressMatched == 1 && this.selected_address_type != -1){

                    globalParameter.addressNotChanged = 0
                    globalParameter.address = formatAddress
                }

                if(this.addressMatched == 1 && this.selected_address_type == -1){
                    globalParameter.addressNotChanged = 1
                    globalParameter.address = this.addressFromDocument
                }

                if(this.idMatched== 1 && this.selected_id_type != -1){
                    globalParameter.IdNotChanged = 0
                    globalParameter.idnumber = this.selected_id_type
                }

                if(this.idMatched== 1 && this.selected_id_type == -1){
                    globalParameter.IdNotChanged = 1
                    globalParameter.idnumber = this.idNumberFromDocument
                }

                if(this.nationalityMatched== 1 && this.selected_nationality != -1){
                    globalParameter.nationalityNotChanged = 0
                    globalParameter.nationality = this.selected_nationality
                }

                 if(this.nationalityMatched== 1 && this.selected_nationality == -1){
                    globalParameter.nationalityNotChanged = 1
                    globalParameter.nationality = this.idNumberFromDocument
                }

                globalParameter.overallStatus  = overallStatus
                const _that = this
                let input_json = {
                    'globalParams' : globalParameter,
                    'localParams' :{
                        "parameter" : _that
                    }
                };
                _that._runGetResolveDocIssue(input_json)
            },
            // closeModalFunc(){
            //     this.$parent.$parent.showStepComponent = false
            // },
            
            // skipDocumentUpload(){
            //     const _that = this
            //     let input_json = {
            //         'globalParams' :{
            //             "step" : _that.step,
            //             "reason" : '1',
            //             "text" : "I have submitted my all required documents. Please verify and enable my account"
            //         },
            //         'localParams' :{
            //             "parameter" : _that
            //         }
            //     };
            //     _that._runSkipDocumentUpload(input_json)
            // },
            // submitNow(){
            //     const _that = this
            //     let IdentityForm = document.getElementById('IdentityForm');
            //     let form_name = new FormData(IdentityForm);
            //     form_name.append("step", _that.step);
            //     let form_data_get = form_name.get('document[]');
            //     if(form_data_get.name != ''){
            //         let input_json =
            //             {
            //                 'globalParams' :{
            //                     "form" : form_name,
            //                 },
            //                 'localParams' :{
            //                     "parameter" : _that,
            //                     "step" : _that.step
            //                 }
            //             };
            //         _that._runRegisterStepFive(input_json)
            //     }else{

            //     }
            // },
            startIpvNow(){
                const _that = this
                let input_json={
                    'globalParams' :{
                       
                    },
                    'localParams' :{ "parameter" : this }
                }
                this.startIpv = !this.startIpv
                this._runGetIdenfyToken(input_json)
            },
            // receiveMessage(e){
            //     console.log(e.data)
            //     if('data' in e && e.data && 'status' in e.data){
            //         if(e.data.status == 'failed'){
            //             this.iframeVar = false
            //         }
            //         if(e.data.status == 'approved'){
            //             this.iframeVar = false
            //         }
            //     }
            // },
            displayAvailableOption(){
                
                // this.iframeVar = false
                // this.showFeaturesDiv = true
                // this.asktoallowNotification = false
             	
             	let input_json={
					'globalParams' :{
						'step' : '3'
					},
					'localParams' :{ "parameter" : this, 'step' : '3'}
				}
             	this._runRegisterStepFive(input_json)
            },
            dontwanttoallow(){
                this.iframeVar = false
                this.showFeaturesDiv = true
                this.asktoallowNotification = false
            },
            intializeSumSub(accessToken, ExtUserId, levelname){
                this.accToken = accessToken
                this.levelname = levelname
                this.user_id = ExtUserId
                const _that = this
                //https://api.sumsub.com
                _that.launchWebSdk('https://test-api.sumsub.com', this.levelname, this.accToken, this.get_user.email, '', '')
            },

            launchWebSdk(apiUrl, flowName, accessToken, applicantEmail, applicantPhone, customI18nMessages) {

            	const _that = this

			    let snsWebSdkInstance = snsWebSdk.Builder(apiUrl, flowName)
			        .withAccessToken( accessToken, (newAccessTokenCallback) => { 
			                // Access token expired
			                // get a new one and pass it to the callback to re-initiate the WebSDK
			                let newAccessToken = this.newAccessToken(); // get a new token from your backend
			                newAccessTokenCallback(newAccessToken)
			        })
			        .withConf(
				        {
				            lang: 'en',
				            email: applicantEmail,
				            phone: applicantPhone,
				            i18n: customI18nMessages,
				            onMessage: (messageType, payload) => {
				                if(messageType == 'idCheck.onApplicantSubmitted'){
		                            _that.displayAvailableOption()
		                        }
		                        if(messageType == 'idCheck.onApplicantResubmitted'){
		                            _that.displayAvailableOption()
		                        }
		                        if(messageType == 'idCheck.applicantStatus'){
		                            if("reviewStatus" in payload && payload.reviewStatus == "completed" ){
		                               if("reviewResult" in payload && "reviewRejectType" in payload.reviewResult && payload.reviewResult.reviewRejectType == 'RETRY'){
		                                    _that.displayAvailableOption()
		                               }else{
		                               		_that.displayAvailableOption()
		                               }
		                            }else if("reviewStatus" in payload && payload.reviewStatus == "pending" ){
		                            	_that.displayAvailableOption()
		                            }else{
		                            	_that.displayAvailableOption()
		                            }
		                        }
				            },
				            uiConf: {
				                customCssStr: "button.submit:active:not(:disabled), button.submit:hover:not(:disabled):not(.disabled):not(:active), button[type=submit]:active:not(:disabled), button[type=submit]:hover:not(:disabled):not(.disabled):not(:active), #loader .round-icon, .round-icon{ background: #25c16f; color: #fff; background-image:none;}button.submit, button[type=submit]{ background: #25c16f; color: #fff;} .step.active .title, h3, h4, .content .desktop p, .document-status h2{color:#414649} .step.active .bullet:before, .step.active.success .bullet:before, .radio-item .checkmark:after{background-color:#25c16f} .mobile-button .fa-icon, .accent{color:#25c16f} .checkbox input:checked~.checkmark{background-color:#25c16f ;border-color:#25c16f} .step.active .line, .step.success .line{background-color:#25c16f} .document-status p, p, .checkbox, .radio-item{color:#888da8;}"
				            },
				            onError: (error) => {
				                _that.displayAvailableOption()
				            },
				        }
			        )
			        .build();

			    // you are ready to go:
			    // just launch the WebSDK by providing the container element for it
			    snsWebSdkInstance.launch('#idensic')
			}

        },    
        created(){          
            this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '3'}})
            if(parseInt(this.get_user.profile.ipv_status)){ this.startIpvNow(); this.getSumSubResp();}
        },
        beforeDestroy: function () {
            let payLoad = {"accessToken": this.accToken, "user_id": this.user_id, "levelname": this.levelname}
            EventBus.$emit('INTIALIZESUMSUB', payLoad);
        }     
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/ipv_component.vue